import { useEffect, useState } from 'react';

/**
 * Subscribe to a CSS media query and re-render when it changes. SSR-safe
 * (returns `false` until mounted). Use for responsive behaviour that can't be
 * expressed in CSS alone — e.g. swapping a table for a card layout on mobile.
 */
export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mql = window.matchMedia(query);
    setMatches(mql.matches);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, [query]);

  return matches;
};
